/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponsibleParty } from './ResponsibleParty';
import {
    ResponsiblePartyFromJSON,
    ResponsiblePartyFromJSONTyped,
    ResponsiblePartyToJSON,
    ResponsiblePartyToJSONTyped,
} from './ResponsibleParty';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface Action
 */
export interface Action {
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    uuid?: string;
    /**
     * 
     * @type {Date}
     * @memberof Action
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    system?: string;
    /**
     * 
     * @type {Array<Property>}
     * @memberof Action
     */
    props?: Array<Property>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Action
     */
    links?: Array<Link>;
    /**
     * 
     * @type {Array<ResponsibleParty>}
     * @memberof Action
     */
    responsibleParties?: Array<ResponsibleParty>;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    remarks?: string;
}

/**
 * Check if a given object implements the Action interface.
 */
export function instanceOfAction(value: object): value is Action {
    return true;
}

export function ActionFromJSON(json: any): Action {
    return ActionFromJSONTyped(json, false);
}

export function ActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Action {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'type': json['type'] == null ? undefined : json['type'],
        'system': json['system'] == null ? undefined : json['system'],
        'props': json['props'] == null ? undefined : ((json['props'] as Array<any>).map(PropertyFromJSON)),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'responsibleParties': json['responsibleParties'] == null ? undefined : ((json['responsibleParties'] as Array<any>).map(ResponsiblePartyFromJSON)),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function ActionToJSON(json: any): Action {
    return ActionToJSONTyped(json, false);
}

export function ActionToJSONTyped(value?: Action | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
        'type': value['type'],
        'system': value['system'],
        'props': value['props'] == null ? undefined : ((value['props'] as Array<any>).map(PropertyToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'responsibleParties': value['responsibleParties'] == null ? undefined : ((value['responsibleParties'] as Array<any>).map(ResponsiblePartyToJSON)),
        'remarks': value['remarks'],
    };
}

